<template lang="html">
  <div class="dendrogram-container"></div>
</template>

<script>
// Dendrogram component
// render a dendrogram with d3js
// this is used to demo the video clustering, but probably won't be kept in the long term

import * as d3 from 'd3'

export default {
  props: ['root'],
  mounted () {
    this.renderTree()
  },
  methods: {
    renderTree () {
      const nodeSize = 52
      const leafSize = 48
      const branchSize = 4
      const padding = 24

      const root = d3.hierarchy(this.root)
      // render the dendrogram as a tree (which is a more space-efficient layout)
      // use d3.cluster instead of d3.tree if you want to render
      // the dendrogram as an actual dendrogram and not a tree
      const clusterFactory = d3.tree()
        .nodeSize([nodeSize, nodeSize])
      const cluster = clusterFactory(root)
      const links = cluster.links()
      const nodes = cluster.descendants()

      // There doesn't seem to be any way to retrieve the cluster size
      // in d3js v5.5.0 (d3-hierarchy 1.1.6).
      // https://github.com/d3/d3-hierarchy/blob/v1.1.6/README.md#cluster_size
      // Contrary to what the documentation states calling size() on the tree or
      // cluster doesn't return the current size.
      // As a workaround, find the boundaries by inspecting all the nodes.

      let xmin = 0
      let xmax = 0
      let ymin = 0
      let ymax = 0

      cluster.each((node) => {
        xmin = Math.min(xmin, node.x)
        xmax = Math.max(xmax, node.x)
        ymin = Math.min(ymin, node.y)
        ymax = Math.max(ymax, node.y)
      })

      // x and y are flipped?

      const width = ymax - ymin
      const height = xmax - xmin

      const svg = d3.select(this.$el)
         .append('svg')
         .attr('width', width + leafSize / 2 + padding * 2)
         .attr('height', height + leafSize + padding * 2)
         .append('g')
         .attr('transform', `translate(${padding}, ${padding + leafSize / 2 + -xmin})`)

      const defs = svg.append('svg:defs')

      for (let leaf of cluster.leaves()) {
        defs.append('svg:pattern')
           .attr('id', leaf.data.name)
           .attr('width', leafSize)
           .attr('height', leafSize)
           .attr('patternUnits', 'objectBoundingBox')
           .append('svg:image')
           .attr('xlink:href', leaf.data.thumb)
           .attr('width', leafSize)
           .attr('height', leafSize)
           .attr('x', 0)
           .attr('y', 0)
           .attr('preserveAspectRatio', 'xMidYMid slice')
      }

      svg.selectAll('.link')
        .data(links)
        .enter()
        .append('path')
        .attr('class', 'link')
        .attr('d', d3.linkHorizontal()
          .x((d) => { return d.y })
          .y((d) => { return d.x })
        )
      const node = svg.selectAll('.node')
        .data(nodes)
        .enter()
        .append('g')
        .attr('class', 'node')
        .attr('transform', (d) => {
          return `translate(${d.y}, ${d.x})`
        })
      node.filter((d) => {
        return d.children
      }).append('circle')
        .attr('class', (d) => {
          return d.parent ? 'branch' : 'root'
        })
        .attr('r', branchSize)
      node.filter((d) => {
        return !d.children
      }).append('circle')
        .attr('r', leafSize / 2)
        .attr('class', 'leaf')
        .style('fill', '#fff')
        .style('fill', (d) => {
          return `url(#${d.data.name})`
        })
      node.on('click', (d) => {
        if (d.parent) {
          console.log(d.data.name)
        }
      })
    }
  }
}
</script>

<style lang="sass">
.dendrogram-container
  svg
    margin: 25px

  .node
    font: 10px sans-serif
    // cursor: pointer

    circle
      stroke-width: 1.5px

    circle.branch
     fill: #fff
     stroke: #FF7289

    circle.root
      cursor: default
      fill: #fff
      stroke: #ccc

  .link
    fill: none
    stroke: #ddd
    stroke-width: 1.25px
</style>



// WEBPACK FOOTER //
// MarkerDendrogram.vue?1e89b5f4